import React from 'react';
import './scss/PhotoGallery.scss';
import img1 from '../../assets/img/gallery/01.png';
import img2 from '../../assets/img/gallery/02.png';
import img4 from '../../assets/img/gallery/04.png';
import logo1 from '../../assets/img/logo/01.png';
import logo2 from '../../assets/img/logo/02.png';
import logo3 from '../../assets/img/logo/03.png';
import logo4 from '../../assets/img/logo/04.png';
import logo5 from '../../assets/img/logo/05.png';
import BreadCrumb from '../ShearCompo/BreadCrumb/BreadCrumb';
import { useTranslation } from 'react-i18next';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';

const PhotoGallery = () => {
    const images = [logo1, logo2, logo3, logo4, logo5];
    let { t } = useTranslation();
    // carousel settings
    const settings = {
        dots: false,
        infinite: true,
        speed: 2000,
        autoplay: true,
        pauseOnHover: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                },
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    return (
        <div className='pt-2' id="photo_gallery">
            <div className='row'>
                <div className='col-12'>
                    <img src={img1} alt="" className="w-100" />
                </div>
                <div className="col-md-6 md:pr-0">
                    <img src={img2} alt="" className='w-100' />
                </div>
                <div className="col-md-6 md:pl-0">
                    <img src={img2} alt="" className='w-100' />
                </div>
                <div className="col-12 ">
                    <img src={img4} alt="" className='w-100' />
                </div>
            </div>
            <div className="border-b-4 pt-2 border-dashed border-gray-800"></div>
            <BreadCrumb title={t("partner")} />
            <Slider {...settings}>
                {images.map((image, index) => (
                    <div key={index} className="inline-block px-2 logoArea">
                        <div className='logoParent'>
                            <img
                                className=""
                                src={image}
                                alt={index}
                            />
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default PhotoGallery;